/**
 * @description Нужно отфильтровать продукты по white list для того что бы скрыть продукты, которые ломают флоу.
 */
export const PRODUCTS_WHITE_LIST = [
  'insurance',
  'sms-ticket',
  'sms-info',
  'luggage-packing',
  'charity-bolashak',
  'superflex',
  'sms-schedule',
  'sms-reminder',
  'sms-plan',
  'checkin',
  'medical-insurance',
  'roaming',
  'shapagat',
  'flight-delay-insurance',
];
